import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectPartOfFilter = createSelector(
  [(store: RootState) => store.locations.partOfFilter],
  (data) => data
);
